import Moment from "react-moment";

export function DateView({ date, format = "DD/MM/YYYY" }) {
  return <Moment format={format}>{date}</Moment>;
}
